/* */
import React, { useEffect, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Container from 'components/Container';
import Navbar from './components/Navbar';
import Content from './components/Content';
import actions from 'redux/actions';
import Loading from 'components/Loading';
import getUser from 'redux/selector/getUser';
import roles from 'consts/roles';
import { getQuerySearch } from 'helpers';

const { getGuideline, getGuidelineByRole } = actions;

const GuidelinePreviewPage = (props) => {
  //! State
  const dispatch = useDispatch();
  const history = useHistory();
  const userInfo = getUser();
  const authReducer = useSelector((state) => state.authReducer);
  const guidelineReducer = useSelector((state) => state.guidelineReducer);
  const isFetchingUser = useSelector((state) => state.userServletReducer.isFetching);

  const { sessionId, isLogin } = authReducer;
  const { isLoadingGuide, guideLine, guideLineByRole, isLoadingGuideByRole } = guidelineReducer;
  const { role } = userInfo;
  const query = getQuerySearch(history);

  console.log('rolerole', query, role);

  //! Effect
  useEffect(() => {
    if (isLogin && sessionId && role) {
      if (role === roles.superAdmin && query.role) {
        dispatch(getGuidelineByRole({ role: query.role }));
      } else {
        dispatch(getGuideline());
      }
    }
  }, [isLogin, sessionId, role]);

  //! Constant
  const guideLineMemo = useMemo(() => {
    if (role === roles.superAdmin && query.role) {
      return guideLineByRole;
    }
    return guideLine;
  }, [guideLine, guideLineByRole, role, query.role]);

  const loadingMemo = useMemo(() => {
    if (role === roles.superAdmin && query.role) {
      return isLoadingGuideByRole;
    }

    return isLoadingGuide;
  }, [isLoadingGuide, isLoadingGuideByRole, role, query.role]);

  //! Render
  const renderContent = () => {
    if (!loadingMemo && isLogin && role) {
      if (isEmpty(guideLineMemo)) {
        return 'No content release!';
      }

      return (
        <Container>
          <div className='guide-container'>
            <Navbar />
            <Content dataGuideLine={guideLineMemo} />
          </div>
        </Container>
      );
    }

    return null;
  };

  return (
    <Container>
      <Loading size='md' type='fullScreen' showLoading={isFetchingUser || loadingMemo} />
      {renderContent()}
    </Container>
  );
};
export default GuidelinePreviewPage;
